var _style, _g, _g2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 119.9 29.2",
    style: {
      enableBackground: "new 0 0 119.9 29.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4A4A4A;}\n\t.st1{fill:url(#SVGID_1_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.9,16.4c0-1.2-0.2-2.4-0.6-3.6c-0.4-1.1-1.1-2.1-1.9-2.8c-0.8-0.8-1.8-1.4-2.9-1.7 c-1.1-0.4-2.2-0.6-3.4-0.6c-1.1,0-2.2,0.2-3.2,0.5c-0.1,0-0.2,0.1-0.3,0.1l-0.6,0.2V2.7c0-0.7-0.3-1.4-0.9-2 c-0.5-0.5-1.2-0.8-2-0.8h0c-1.5,0-2.7,1.2-2.7,2.7v23.7c0,0.7,0.3,1.4,0.9,2c0.5,0.5,1.2,0.8,1.9,0.8h0.1c1.5,0,2.7-1.2,2.7-2.7 v-8.3c0-0.7,0.1-1.4,0.3-2.1c0.2-0.6,0.5-1.1,0.8-1.5c0.3-0.4,0.8-0.7,1.2-1c0.5-0.2,1.1-0.4,1.6-0.4H50c0.5,0,1,0.1,1.4,0.2 c0.7,0.2,1.3,0.7,1.5,1.4c0.2,0.6,0.3,1.1,0.3,1.7v9.9c0,1.5,1.3,2.7,2.8,2.7c1.5,0,2.8-1.2,2.8-2.7L58.9,16.4L58.9,16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.5,8.6c-0.6-0.6-1.4-0.9-2.2-0.9c-0.1,0-0.1,0-0.2,0c-1,0-2,0.2-3,0.5c-0.7,0.2-1.4,0.5-2,0.9l-0.3,0.2 L67.5,9c-0.5-0.5-1.3-0.8-2-0.8c-1.5,0-2.8,1.2-2.8,2.7v15.5c0,0.8,0.3,1.4,0.9,2c0.5,0.5,1.2,0.8,1.9,0.8c1.6,0,2.8-1.2,2.8-2.8 v-7.2c0-0.9,0.1-1.7,0.4-2.5c0.2-0.7,0.6-1.4,1-1.9c0.5-0.5,1-0.9,1.7-1.2c0.6-0.2,1.3-0.4,2-0.4c0.2,0,0.3,0,0.5,0H74 c0.6,0,1.2-0.2,1.7-0.6c0.5-0.4,0.8-1.1,0.8-1.7C76.5,10,76.1,9.2,75.5,8.6L75.5,8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11,8C4.8,8,0,12.6,0,18.6s4.7,10.6,10.9,10.6s11-4.6,11-10.6S17.3,8,11,8z M10.9,12.4 c3.3,0,5.9,2.7,5.9,6.2v0.1c0,3.5-2.5,6.1-5.8,6.1S5.1,22,5.1,18.6S7.6,12.4,10.9,12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.1,7.7h-4.1V3c0-1.5-1.2-2.8-2.8-2.8S26.5,1.5,26.5,3v4.7h-1.7c-1.5,0-2.7,1.2-2.7,2.7s1.2,2.7,2.7,2.7 h1.7v13.2c0,1.5,1.2,2.8,2.8,2.8s2.8-1.2,2.8-2.8V13.1h4.1c1.5,0,2.7-1.2,2.7-2.7S37.6,7.7,36.1,7.7z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.0495,
    y1: 31.9716,
    x2: 105.5196,
    y2: 4.21
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09016455,
    style: {
      stopColor: "#D20255"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5733,
    style: {
      stopColor: "#F37D1D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9867,
    style: {
      stopColor: "#FBBF02"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.7,24.2h-3.6c-2.7,0-5.1-1.8-5.6-4.3c-0.4-1.7,0-3.4,1.1-4.8c1.1-1.3,2.7-2.1,4.4-2.1h3.7 c1.4,0,2.5-1.1,2.5-2.5S98.1,8,96.7,8H93c-3.1,0-6,1.3-8,3.7c-2,2.3-2.9,5.4-2.5,8.5c0.7,5.1,5.4,9,10.8,9h3.4 c1.4,0,2.5-1.1,2.5-2.5S98.1,24.2,96.7,24.2z M109,29.2h-3.4c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5h3.6c2.7,0,5.1-1.8,5.6-4.3 c0.4-1.7,0-3.4-1.1-4.8c-1.1-1.3-2.7-2.1-4.4-2.1h-3.7c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5h3.7c3.1,0,6,1.3,8,3.7 c2,2.3,2.9,5.4,2.5,8.5C119,25.3,114.4,29.2,109,29.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logoBlack.a23bc93d21a60b063b46f08126e49cb3.svg";
export { ForwardRef as ReactComponent };